/** localStorage key for VIP tier payload (JSON with tierLabel, expTime, etc.). */
export const VIP_TIER_LEVEL_STORAGE_KEY = 'VIP_TIER_LEVEL'

/**
 * Reads VIP tier label from localStorage (`VIP_TIER_LEVEL`).
 * Value is expected to be JSON like:
 * `{"customerId":...,"tierLabel":"GOLD"...}`
 *
 * @returns {string} `tierLabel` trimmed, or `''` if missing, invalid, expired, or unreadable.
 */
export function getVipTierLabelFromLocalStorage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return ''
  }
  try {
    const raw = window.localStorage.getItem(VIP_TIER_LEVEL_STORAGE_KEY)
    if (raw == null || raw === '') {
      return ''
    }
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') {
      return ''
    }
    if (parsed.tierLabel == null) {
      return ''
    }
    return String(parsed.tierLabel).trim()
  } catch {
    return ''
  }
}
